define((require) => {
    "use strict";

    const ContentCollection = require("data/ContentCollection");
    const RestApi           = require("shared/services/RestApi");
    const UrlUtil           = require("shared/util/UrlUtil");
    const SyncManager       = require("shared/services/sync/SyncManager");

    /**
     * Represents a content collection of publishables (experiences and/or groups), supporting "lazy loading".
     *
     * @see  ContentCollection
     * @class PublishableCollection
     */
    return ContentCollection.extend("PublishableCollection", {

        url(options = {}) {
            const project = options.project;
            const maxScenes = options.maxScenes;

            let baseUrl = RestApi.pathToCollection(RestApi.Collections.PUBLISHABLES);

            if (project) {
                baseUrl = RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.PUBLISHABLES);
            }

            // maxScenes null means fetching all scenes.
            if (maxScenes !== undefined && maxScenes !== null) {
                return UrlUtil.appendParamObject(baseUrl, {maxScenes});
            }

            return baseUrl;
        }

    }, {

        count(options = {}) {
            const project = options.project;
            const target = SyncManager.target("PublishableCollection.count");
            let url;

            if (project) {
                url = RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.PUBLISHABLES_COUNT);
            } else {
                url = RestApi.pathToCollection(RestApi.Collections.PUBLISHABLES_COUNT);
            }

            return SyncManager.get(url, target);
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/data/PublishableCollection.js